import React from "react"
import styles from "./preloader.module.css"

interface Props {
    children?: string
}

export const Preloader: React.FunctionComponent<Props> = (props) => {
    return <div className={styles.preloader}>{props.children}</div>
}
